import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Button from '../../../component/ui/Button';
import { enUS } from 'date-fns/locale';
import { DateRange } from 'react-date-range';

const CustomDateSelect = ({ isOpen, onCLose, setFilterparam, customDates, setCustomDates }) => {

	const handleSubmit = () => {
		const formatDate = (date) => {
			const adjusted = new Date(date);
			adjusted.setDate(adjusted.getDate() + 1);
			return adjusted.toISOString().split('T')[0];
		};

		const startDate = formatDate(customDates.startDate);
		const endDate = formatDate(customDates.endDate);

		let param = {
			filterValue: {
				startDate: startDate,
				endDate: endDate,
			},
			filterBy: 'date',
		};

		setFilterparam(param);
		onCLose();
	};

	return (
		<div>
			<div
				style={{
					width: '100%',
					borderRadius: '12px',
					overflow: 'hidden',
				}}
			>
				<DateRange
					editableDateInputs={true}
					onChange={(range) => {
						setCustomDates(range.selection);
					}}
					moveRangeOnFirstSelection={false}
					ranges={[customDates]}
					locale={enUS}
				/>
				<div className="text-center px-5 py-3 bg-white d-flex gap-2 justify-content-start">
					<Button
						type="button"
						button="Save"
						className="btn-primary add-pgroup"
						onClick={handleSubmit}
					/>
					<p></p>
					<Button
						type="button"
						button="Cancel"
						className="btn-dark add-pgroup"
						onClick={onCLose}
					/>
				</div>
			</div>
		</div>
	);
};

export default CustomDateSelect;
